import { useCallback } from 'react';
import { Button, Avatar } from 'antd';
import LanguageDropdown from './LanguageDropdown';
import LogoutImage from '../assets/images/logout-red-icon.svg';
import { useTranslation } from 'react-i18next';
import { HomeOutlined } from '@ant-design/icons';
import { useBatchId } from '../hooks/useBatchId';
import { SELECT_MODULE } from '../shared/Routes';

interface WebAppHeaderProps {
	logout?: () => void | Promise<void>;
	username?: string;
	profileImage?: string;
	showHome?: boolean;
}

export const ApplicantWebHeader = ({
	logout,
	username,
	profileImage,
	showHome,
}: WebAppHeaderProps) => {
	const { t } = useTranslation();
	const handleLogoutClick = useCallback(() => {
		if (logout) {
			void logout();
		}
	}, [logout]);
	const { navigateWithBatchId } = useBatchId();
	const logoutText = t('logout');
	const home = t('home');
	const LogoutIcon = () => (
		<>
			<img src={LogoutImage} alt="Logout Icon" />
		</>
	);

	const handleHomeClick = useCallback(() => {
		navigateWithBatchId(SELECT_MODULE);
	}, [navigateWithBatchId]);

	return (
		<div className="hidden md:flex items-center justify-between px-4 space-x-6">
			{/* Showing Home button to Admins, Approvers and ZCs */}
			{showHome && (
				<div
					className="flex items-center gap-x-2 py-1.5 px-3 border border-solid border-[#D9D9D9] rounded-lg cursor-pointer"
					onClick={handleHomeClick}
				>
					<HomeOutlined size={30} />
					<span className="font-sans font-medium text-gray-700 text-sm">
						{home}
					</span>
				</div>
			)}

			{/* Profile Section */}
			<div className="flex items-center gap-x-3">
				<Avatar
					src={profileImage}
					size={36}
					className="border border-gray-300"
				/>
				<span className="font-sans font-medium text-gray-700 text-sm">
					{username}
				</span>
			</div>

			{/* Language Dropdown */}
			<div>
				<LanguageDropdown className="w-28 text-center" />
			</div>

			{/* Logout Section */}
			<div className="flex items-center min-w-max">
				<LogoutIcon />
				<Button
					type="link"
					shape="round"
					onClick={handleLogoutClick}
					size="small"
					className="text-red hover:!text-red font-sans font-medium !justify-start !p-1"
				>
					{logoutText}
				</Button>
			</div>
		</div>
	);
};
